import { apiClient } from '../../app/api/client';
import type { CurveImportRead } from './types';
import type {
  CurveLibraryDetail, CurveLibraryFork, CurveLibraryForkPage,
  CurveLibraryForkResult, CurveLibraryPage, CurveLibrarySearch,
  CurveLibrarySubmission,
} from './libraryTypes';

export interface CurveLibraryApi {
  resolveImport(importId: string): Promise<{ imported: CurveImportRead | null }>;
  search(filters: CurveLibrarySearch, offset?: number): Promise<CurveLibraryPage>;
  getEntry(id: string): Promise<CurveLibraryDetail>;
  sourceUrl(id: string): string;
  submit(input: CurveLibrarySubmission): Promise<CurveLibraryDetail>;
  forkByImport(importId: string): Promise<CurveLibraryFork>;
  reviewQueue(offset?: number): Promise<CurveLibraryPage>;
  forkQueue(offset?: number): Promise<CurveLibraryForkPage>;
  review(id: string, decision: 'approved' | 'rejected' | 'withdrawn', notes: string): Promise<CurveLibraryDetail>;
  fork(id: string, reason: string, requestingImportId: string | null): Promise<CurveLibraryForkResult>;
}

export const curveLibraryApi: CurveLibraryApi = {
  resolveImport: (id) => apiClient.post(`/curve-library/imports/${id}/resolve`, {}),
  search: (filters, offset = 0) => {
    const query = new URLSearchParams({ offset: String(offset), limit: '50' });
    for (const key of ['source_sha256', 'manufacturer', 'model', 'trim_label'] as const) {
      const value = filters[key];
      if (value?.trim()) query.set(key, value.trim());
    }
    return apiClient.get(`/curve-library/entries?${query.toString()}`, { session: true });
  },
  getEntry: (id) => apiClient.get(`/curve-library/entries/${id}`, { session: true }),
  sourceUrl: (id) => `/api/v1/curve-library/entries/${id}/source`,
  submit: (input) => apiClient.post('/curve-library/submissions', { json: input }),
  forkByImport: (id) => apiClient.get(`/curve-library/forks/by-import/${id}`, { session: true }),
  reviewQueue: (offset = 0) => apiClient.get(`/curve-library/review-queue?offset=${offset}&limit=50`, { session: true }),
  forkQueue: (offset = 0) => apiClient.get(`/curve-library/forks/review-queue?offset=${offset}&limit=50`, { session: true }),
  review: (id, decision, notes) => apiClient.post(`/curve-library/entries/${id}/review`, { json: { decision, notes } }),
  fork: (id, reason, requestingImportId) => apiClient.post(`/curve-library/entries/${id}/fork`, {
    json: { reason, requesting_import_id: requestingImportId },
  }),
};
